import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/common/core-services/common.Service';
import { EmailSubscriptionPlanService } from 'src/app/common/services/emailSubscriptionPlanService/email-subscription-plan.service';
import { MasterDropdownService } from 'src/app/common/services/MasterDropdownServices/master-dropdown.service';

@Component({
  selector: 'app-add-email-subscription',
  templateUrl: './add-email-subscription.component.html',
  styleUrls: ['./add-email-subscription.component.css']
})
export class AddEmailSubscriptionComponent implements OnInit {

  form: FormGroup;
  subscriptionID: number;
  data: string;
  planTypeDropdown:any;
  planTypeStautusDropdown:any;
  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private emailSubscriptionPlanService: EmailSubscriptionPlanService,
    private toaster: ToastrService,
    private router: Router,
    private masterDropdownService :MasterDropdownService,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      emailSubscriptionPlanID: [0],//
      emailPlanName: ['', Validators.required], 
      emailPrice: ['', [Validators.required, Validators.pattern('[0-9]+'), Validators.min(1)]],
      limit: ['', [Validators.required, Validators.pattern('[0-9]+'), Validators.min(1)]],
      emailPlanStatusID: ['', Validators.required],//
      emailPackID: ['', Validators.required],//
      description: ['', Validators.required],//
    });

    this.masterDropdown();
  }

  onSubmit() {
    debugger
    if (this.form.invalid) {
      return;
    }
    this.addEmailSubscriptionPlan();
    //this.form.reset();
    // this.form.controls.emailSubscriptionPlanID.clearValidators();
    // this.form.controls.emailPlanName.clearValidators();
    // this.form.controls.emailPrice.clearValidators();
    // this.form.controls.emailPlanStatusID.clearValidators();
    // this.form.controls.emailPackID.clearValidators();
    // this.form.controls.description.clearValidators();
  }

  addEmailSubscriptionPlan() {
    console.log("this.form.value", this.form.value)
    this.form.value.limit = Number(this.form.value.limit)
    this.emailSubscriptionPlanService.AddEmailSubscriptionPlan(this.form.value).subscribe((res: any) => {
      if (res.status > 0) {
        this.toaster.success(res.message);
        this.router.navigate(['/email-subs'])
      }
      else {
        this.toaster.error(res.message);
      }
    });
  }

  masterDropdown() {
    this.masterDropdownService.GetPlanTypeDropdown().subscribe((res: any) => {
      this.planTypeDropdown = res.responseData;
    });
    this.masterDropdownService.GetPlanTypestausDropdown().subscribe((res: any) => {
      this.planTypeStautusDropdown = res.responseData
    })
  }
  allowOnlyNumber(event: any) {
    this.commonService.allowOnlyNumber(event);
  }
  allowAlphabetOnly(event: any) {
    this.commonService.allowAlphabetOnly(event);
  }

}
